<template>
  <s-modal
    size="md"
    v-model="showModalHandler"
    :title="$t('engineering.analysis-processing.process-samples')"
    :ok-title="$t('actions.confirm')"
    :ok-disabled="!userName"
    @cancel="closeModal"
    @ok="confirmProcessRequest"
    @show="onShow"
  >
    <b-row>
      <b-col
        cols="12"
        v-html="$t('engineering.processing-modal-message')"
      />
      <b-col
        cols="12"
        class="my-5"
      >
        <label>
          {{ $t('engineering.analysis-processing.inform-login') }}
        </label>
        <b-form-input v-model="userName">
        </b-form-input>
      </b-col>
    </b-row>
  </s-modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    userName: null,
  }),
  computed: {
    showModalHandler: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    onShow() {
      this.userName = null;
    },
    confirmProcessRequest() {
      this.$emit('submit-process-request', this.userName);
    },
    closeModal() {
      this.showModalHandler = false;
    },
  },
};
</script>
